var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzurelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3381 3.0025H62.9288L32.2105 94.0709C32.0535 94.536 31.8249 94.9737 31.533 95.3684C31.2417 95.7635 30.8905 96.1097 30.4917 96.396C30.0929 96.6823 29.6529 96.9048 29.1853 97.0548C28.7178 97.2048 28.2303 97.2823 27.7402 97.2823H4.71122C3.96367 97.2823 3.22612 97.1048 2.56108 96.7623C1.89533 96.4207 1.32064 95.9253 0.884716 95.3172C0.448508 94.7091 0.163143 94.0059 0.0521613 93.2658C-0.059096 92.5258 0.00840845 91.7695 0.247174 91.0607L28.8666 6.21146C29.0228 5.74643 29.2516 5.3089 29.5441 4.91387C29.8354 4.51885 30.1879 4.17258 30.5854 3.88631C30.9842 3.60004 31.4242 3.37752 31.8918 3.22751C32.3593 3.0775 32.8468 3 33.3369 3V3.00125L33.3381 3.0025Z",
    fill: "url(#paint0_linear_790_307)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8866 97.2825H61.3161C61.0199 97.2825 60.7236 97.2549 60.4311 97.1987C60.1398 97.1437 59.8535 97.0612 59.5773 96.9524C59.301 96.8437 59.036 96.7087 58.7847 96.5512C58.5338 96.3926 58.2981 96.211 58.0809 96.0086L27.929 67.8493C27.61 67.5515 27.3879 67.1648 27.2914 66.7392C27.195 66.3137 27.2289 65.8689 27.3888 65.4629C27.5486 65.0569 27.827 64.7084 28.1877 64.4628C28.549 64.2178 28.9753 64.0865 29.4116 64.0865H76.3346L87.8841 97.2837L87.8866 97.2825Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.035 3.0025L42.3212 64.0928L76.1659 64.0853L87.7754 97.2825H61.3049C61.0311 97.28 60.7574 97.255 60.4874 97.2062C60.2173 97.1575 59.9523 97.0862 59.6948 96.9912C59.1784 96.8031 58.6981 96.5278 58.2747 96.1774L37.9209 77.1812L32.223 93.9848C32.0755 94.4048 31.873 94.8036 31.6205 95.1698C31.1144 95.9067 30.4221 96.4963 29.6141 96.8787C29.2118 97.069 28.7859 97.2048 28.3478 97.2825H4.72495C3.9699 97.285 3.22486 97.105 2.55356 96.7575C1.88217 96.4102 1.30424 95.9065 0.868629 95.2887C0.433022 94.671 0.152541 93.9575 0.0508979 93.2085C-0.0503777 92.4591 0.0297923 91.6965 0.284663 90.9846L28.8578 6.27522C29.0065 5.80144 29.2303 5.35516 29.5203 4.95263C29.8091 4.5501 30.1616 4.19508 30.5616 3.90256C30.9617 3.61004 31.4067 3.38253 31.878 3.23002C32.3493 3.0775 32.843 3 33.3393 3.0025H63.0363H63.035Z",
    fill: "url(#paint1_linear_790_307)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7524 91.0609C99.9913 91.7701 100.059 92.5258 99.9487 93.266C99.8376 94.0059 99.5527 94.7089 99.1174 95.3174C98.6814 95.9252 98.1069 96.4204 97.4415 96.7621C96.7761 97.1039 96.0389 97.2823 95.2909 97.2826H62.3112C63.0587 97.2826 63.7963 97.1038 64.4626 96.7625C65.1276 96.4212 65.7027 95.925 66.1389 95.3174C66.5752 94.7099 66.8602 94.0061 66.9715 93.266C67.0828 92.526 67.0153 91.7697 66.7765 91.0609L38.1558 6.20903C37.8408 5.27432 37.2405 4.46197 36.4395 3.88637C36.0419 3.6001 35.6019 3.37884 35.1356 3.22883C34.6693 3.07882 34.1818 3.00256 33.693 3.00256H66.6715C67.1615 3.00256 67.6478 3.07882 68.1153 3.22883C68.5816 3.37884 69.0216 3.60135 69.4204 3.88637C69.8179 4.17264 70.1692 4.51891 70.4605 4.91269C70.7518 5.30647 70.9793 5.74399 71.1368 6.20903L99.7574 91.0609H99.7524Z",
    fill: "url(#paint2_linear_790_307)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_790_307",
    x1: 44.1376,
    y1: 9.99045,
    x2: 13.3856,
    y2: 100.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_790_307",
    x1: 53.7257,
    y1: 52.3183,
    x2: 46.6127,
    y2: 54.7309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_790_307",
    x1: 49.8004,
    y1: 7.34035,
    x2: 83.5526,
    y2: 97.2588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzurelogo);
export default __webpack_public_path__ + "static/media/azurelogo.b7431658beb416c4163a5c19a457307d.svg";
export { ForwardRef as ReactComponent };